import { jsx as _jsx } from "react/jsx-runtime";
import * as Ariakit from '@ariakit/react';
export const Container = ({ className, children, isExpanded, defaultIsExpanded = false, onChange, ...rest }) => {
    return (_jsx("div", { className: className, ...rest, children: _jsx(Ariakit.DisclosureProvider, { defaultOpen: defaultIsExpanded, open: isExpanded, setOpen: onChange, children: children }) }));
};
//# sourceMappingURL=Container.js.map